import React from 'react';
import { BrainIcon, HeartIcon, RefreshCcwIcon, ZapIcon } from 'lucide-react';
export function Benefits() {
  return <section className="py-16 bg-white" id="learn-more" data-id="element-14">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-15">
        <div className="text-center mb-12" data-id="element-16">
          <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl" data-id="element-17">
            Transform Your Mind, Transform Your Life
          </h2>
          <p className="mt-4 text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-18">
            Discover how this powerful guide can help you unlock your full
            potential and regain the vitality you deserve.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-19">
          <div className="bg-blue-50 p-6 rounded-lg" data-id="element-20">
            <div className="bg-blue-100 rounded-full w-12 h-12 flex items-center justify-center mb-4" data-id="element-21">
              <BrainIcon className="h-6 w-6 text-blue-600" data-id="element-22" />
            </div>
            <h3 className="text-lg font-medium text-gray-900 mb-2" data-id="element-23">
              Mental Flexibility
            </h3>
            <p className="text-gray-600" data-id="element-24">
              Learn powerful techniques to develop mental agility and
              adaptability regardless of your age.
            </p>
          </div>
          <div className="bg-blue-50 p-6 rounded-lg" data-id="element-25">
            <div className="bg-blue-100 rounded-full w-12 h-12 flex items-center justify-center mb-4" data-id="element-26">
              <RefreshCcwIcon className="h-6 w-6 text-blue-600" data-id="element-27" />
            </div>
            <h3 className="text-lg font-medium text-gray-900 mb-2" data-id="element-28">
              Complete Reset
            </h3>
            <p className="text-gray-600" data-id="element-29">
              Discover a step-by-step system to reset your mindset and break
              free from limiting beliefs.
            </p>
          </div>
          <div className="bg-blue-50 p-6 rounded-lg" data-id="element-30">
            <div className="bg-blue-100 rounded-full w-12 h-12 flex items-center justify-center mb-4" data-id="element-31">
              <HeartIcon className="h-6 w-6 text-blue-600" data-id="element-32" />
            </div>
            <h3 className="text-lg font-medium text-gray-900 mb-2" data-id="element-33">
              Emotional Resilience
            </h3>
            <p className="text-gray-600" data-id="element-34">
              Build unshakable emotional strength to handle life's challenges
              with grace and positivity.
            </p>
          </div>
          <div className="bg-blue-50 p-6 rounded-lg" data-id="element-35">
            <div className="bg-blue-100 rounded-full w-12 h-12 flex items-center justify-center mb-4" data-id="element-36">
              <ZapIcon className="h-6 w-6 text-blue-600" data-id="element-37" />
            </div>
            <h3 className="text-lg font-medium text-gray-900 mb-2" data-id="element-38">
              Renewed Energy
            </h3>
            <p className="text-gray-600" data-id="element-39">
              Implement practical daily habits that boost your mental clarity
              and physical vitality.
            </p>
          </div>
        </div>
        <div className="mt-12 text-center" data-id="element-40">
          <p className="text-lg text-gray-700 mb-6 max-w-3xl mx-auto" data-id="element-41">
            <span className="font-semibold" data-id="element-42">
              Why settle for feeling tired and overwhelmed
            </span>{' '}
            when you could be experiencing the mental clarity and energy you had
            in your youth?
          </p>
          <a href="#buy-now" className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" data-id="element-43">
            Get Your Copy Today
          </a>
        </div>
      </div>
    </section>;
}